import messages from '../messages';

const errorMessageMapping = {
  required: 'RequiredFieldMessage',
  invalidPostalCode: 'InvalidPostalCodeMessage',
};

/* eslint-disable import/prefer-default-export */
export const getDefaultErrorMessages = (intl) => {
  const { formatMessage } = intl;
  const errorMessages = {};

  Object.keys(errorMessageMapping).forEach((k) => {
    errorMessages[k] = formatMessage(messages[errorMessageMapping[k]]);
  });
  return errorMessages;
};
